module.exports = __webpack_public_path__ + "static/img/cost-saving.d676e30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time-attendance/cost-saving.png
// module id = L0Wq
// module chunks = 0